import { Controller } from "@hotwired/stimulus"

// FD-199: type-to-confirm for destructive actions. The submit button stays
// disabled until the typed value matches `expectedValue` (e.g. the workspace slug).
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  connect() {
    this.check()
  }

  check() {
    const match = this.inputTarget.value.trim() === this.expectedValue
    this.submitTarget.disabled = !match
  }
}
